import { PropsWithChildren, ReactNode } from "react";

import { twMerge } from "tailwind-merge";

import { ClassName } from "shared/types";

type Props = {
  title?: ReactNode;
  titleClassName?: string;
} & ClassName;

export const PageLayout = ({
  className,
  titleClassName,
  title,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div className={twMerge("flex grow flex-col p-8", className)}>
      {typeof title === "string" ? (
        <h1 className={twMerge("text-3xl font-semibold", titleClassName)}>
          {title}
        </h1>
      ) : (
        title
      )}
      {children}
    </div>
  );
};
